// Mock health centers data
export const mockHealthCenters = {
    us: [
      { id: 1, name: 'Mayo Clinic' },
      { id: 2, name: 'Cleveland Clinic' },
      { id: 3, name: 'Johns Hopkins Hospital' },
      { id: 4, name: 'Massachusetts General Hospital' },
      { id: 5, name: 'UCLA Medical Center' },
      { id: 6, name: 'New York-Presbyterian Hospital' },
      { id: 7, name: 'Stanford Health Care' },
      { id: 8, name: 'UCSF Medical Center' },
    ],
    cl: [
      { id: 1, name: 'Clínica Las Condes' },
      { id: 2, name: 'Hospital Clínico Universidad de Chile' },
      { id: 3, name: 'Clínica Alemana' },
      { id: 4, name: 'Hospital del Salvador' },
      { id: 5, name: 'Hospital Barros Luco Trudeau' },
      { id: 6, name: 'Clínica Santa María' },
      { id: 7, name: 'Hospital Sótero del Río' },
      { id: 8, name: 'Hospital San José' },
      { id: 9, name: 'Centro de Salud Familiar Rauco' },
    ]
  };
  
  // Health color constant
  export const HEALTH_GREEN = '#4CAF50';